<template>
  <a
    class="shadow-link"
    :href="href"
    :target="target"
    :rel="rel"
  >
    <ShadowBox
      class="shadow-box"
      :class="{'text-left': textLeft}"
      opacity="_50"
    >
      <span class="text">{{ text }}</span>
    </ShadowBox>
  </a>
</template>

<script>
import ShadowBox from '@/components/atoms/ShadowBox.vue';

export default {
  name: 'shadow-link',

  components: {
    ShadowBox,
  },

  props: {
    text: {
      type: String,
    },
    textLeft: {
      type: Boolean,
      default: false,
    },
    href: {
      type: String,
      required: true,
    },
    target: {
      type: String,
      default: '_self',
    },
    rel: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.shadow-link{
  font-size: 14px;
  color: #ffffff !important;
  text-decoration: none;
  cursor: pointer;
  transition: 0.4s;
  display: block;
  &:hover {
    opacity: 0.4;
    color: #ffffff !important;
  }
  .shadow-box{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    border-radius: 0px;
    .fa-angle-right{
      position: absolute;
      right: 10px;
      width: 6px;
      height: 14px;
    }
  }
  .shadow-box.text-left{
    justify-content: flex-start;
  }
}
@media screen and (max-width: $tabletWidth) {
  .shadow-link {
    color: #ffffff !important;
    width: 50%;
    &:hover {
      opacity: 1;
      color: #ffffff !important;
    }
    .shadow-box{
    }
  }
}
</style>
